import { motion } from "framer-motion";

const STEPS = [
  {
    num: "01",
    title: "A simple conversation",
    desc:
      "Call us or send a note. We listen first — your loved one’s routines, preferences, and what feels like home.",
  },
  {
    num: "02",
    title: "A personalized care plan",
    desc:
      "Our care manager visits, assesses needs, and builds a plan tailored to the person, not a template.",
  },
  {
    num: "03",
    title: "The right caregiver",
    desc:
      "We match from a bench of vetted caregivers — personality, skills and schedule — and introduce them in person.",
  },
  {
    num: "04",
    title: "Care that evolves",
    desc:
      "Care never stays still. We check in regularly and adjust the plan as needs change.",
  },
];

export default function CareProcess() {
  return (
    <section
      id="process"
      data-testid="care-process"
      className="py-24 md:py-32 bg-[#F3EFE9]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <span className="eyebrow">How it works</span>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight mt-5 leading-[1.03] text-[#1A2621]">
            From first call
            <span className="italic text-[#284A3B]"> to first visit,</span> in days.
          </h2>
        </div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.1 } },
          }}
          className="mt-14 grid md:grid-cols-2 gap-6 md:gap-8"
        >
          {STEPS.map((s) => (
            <motion.div
              key={s.num}
              variants={{
                hidden: { opacity: 0, y: 24 },
                show: {
                  opacity: 1,
                  y: 0,
                  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
                },
              }}
              data-testid={`care-step-${s.num}`}
              className="relative bg-[#FDFBF7] rounded-2xl border border-[#D5DACF] p-8 md:p-10 overflow-hidden group"
            >
              <div className="font-serif-display text-5xl text-[#C86A51]/80 leading-none">
                {s.num}
              </div>
              <h3 className="font-serif-display text-2xl md:text-3xl mt-8 text-[#1A2621] leading-snug">
                {s.title}
              </h3>
              <p className="mt-4 text-[#4A5D54] leading-relaxed">{s.desc}</p>

              {/* Decorative underline */}
              <div className="absolute left-10 right-10 bottom-0 h-px bg-gradient-to-r from-transparent via-[#C86A51]/40 to-transparent translate-y-full group-hover:translate-y-0 transition-transform duration-700" />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
